import { render, staticRenderFns } from "./bindGZH.vue?vue&type=template&id=14407d5a&scoped=true&"
import script from "./bindGZH.vue?vue&type=script&lang=js&"
export * from "./bindGZH.vue?vue&type=script&lang=js&"
import style0 from "./bindGZH.vue?vue&type=style&index=0&id=14407d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14407d5a",
  null
  
)

export default component.exports